import { render, staticRenderFns } from "./SalesPersonAvatar.vue?vue&type=template&id=5d3aa288&scoped=true&"
import script from "./SalesPersonAvatar.vue?vue&type=script&lang=js&"
export * from "./SalesPersonAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3aa288",
  null
  
)

export default component.exports